import React, { useEffect, useMemo, useRef, useState } from "react";
import reel from "../../../../../assets/images/Event-2026/reel1.png";
import reelThadingyutTheme from "../../../../../assets/images/Mini-Game/thadingyut-2025-theme/reel-thadingyut-2025-theme.png";
import reelNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/reel.png";
import attemptCoin from "../../../../../assets/images/Event-2026/user.svg";
import playNow from "../../../../../assets/images/Event-2026/play.png";
import playNowTBN from "../../../../../assets/images/Event-2026/playTBN.png";
import playNowThadingyutTheme from "../../../../../assets/images/Mini-Game/thadingyut-2025-theme/play-now-thadingyut-2025-theme.png";
import playNowNewYearTheme from "../../../../../assets/images/Mini-Game/new-year-2025/play-btn-new.png";
import styled from "styled-components";
import LotoReel from "./LotoReel";

import superAttemptIcon from "../../../../../assets/images/Mini-Game/Coin (1).png";
import {
  curStateEventThingyan2025,
  curStateHome,
  curStateMiniGame,
} from "../../../../../Redux/selector";
import { useDispatch, useSelector, useMiniGameAuth } from "@pages/Events/MiniGame/store";
import { postDataApi } from "../../../../../config/service";
import API_PATH from "../../../../../config/API_PATH";
import { useNavigate } from "@hooks/useNavigate";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { ID_PRIZE } from "../DefineData";
import {
  getDataMissionMiniGame,
  getDataSpinAwardMiniGame,
  getDataSpinUserMiniGame,
  setDataPopupError,
  setDataSpinLeft,
} from "../../../../../Redux/futures/mini-game/action";
import iconLight from "../../../../../assets/images/Mini-Game/light-play-now.png";
import {
  currentDate,
  ID_GIFT_PLAY_LOTO,
  ID_GIFT_PLAY_LOTO_MINIGAME,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../../helper/const";
import { getTurnRemain } from "../../../../../Redux/futures/account/actions";
import PATH from "../../../../../config/PATH";
import PopupIntroGift from "../PopupFooter/PopupIntroGift";
import iconBid from "../../../../../assets/images/Mini-Game/new-year-2025/bid.png";
import iconCoinSuperNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/coin.png";
import { Flex, Input, InputNumber, Pagination, Table } from "antd";
// import { IS_EVENT_THADINGYUT_2025_THEME } from "../../../../../helper/const";
import minusBtnNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/minus-btn.png";
import addBtnNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/add-btn.png";
import addBtn from "../../../../../assets/images/Mini-Game/add-btn.png";
import minusBtn from "../../../../../assets/images/Mini-Game/minus-btn.png";
import PopupFooter from "../PopupFooter";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import iconBidFree from "../../../../../assets/images/Mini-Game/icon-bid-free.png";
import bgCoin from "../../../../../assets/images/Mini-Game/bg-coin-popup-cong.png";
import iconGoodLuck from "../../../../../assets/images/Mini-Game/popup-good-luck-icon.png";
import iconPuzzlePiece from "../../../../../assets/images/Mini-Game/delete-define-piece.png";
import DateD from "../../../../../assets/images/Event-2026/date-D.png";
import DateH from "../../../../../assets/images/Event-2026/date-H.png";
import DateM from "../../../../../assets/images/Event-2026/date-M.png";
import { mediaQueryPoint, useMediaQuery } from "../../../../../utils/hooks";
import { getMiniGameGetMiniGameQuery } from "dataLayer/miniGame";
import { useMutation, useQuery, useQueryClient } from "react-query";
import PopupCongPiece from "../PopupFooter/PopupCongPiece";
import PopupChangeCoin from "../PopupChangeCoin/PopupChangeCoin";
import { postMiniGameChangeAttempt } from "@api/miniGame";
import { queryKeyTurn } from 'dataLayer/user';

const MIN_ROUND = 1;
const MAX_ROUND = 10;

const dataStylePopup = [ID_PRIZE.prize_5, ID_PRIZE.prize_6, ID_PRIZE.prize_8];

const useCountdown = (startTime, endTime) => {
  const calculateTimeLeft = () => {
    if (!startTime || !endTime) {
      return {
        days: "00",
        hours: "00",
        minutes: "00",
      };
    }
    const now = Date.now();

    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();

    // Nếu muốn đếm từ hiện tại tới endTime
    const distance = end - now;

    if (distance <= 0) {
      return {
        days: "00",
        hours: "00",
        minutes: "00",
      };
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    return {
      days: String(days).padStart(2, "0"),
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [startTime, endTime]);

  return timeLeft;
};

function Reel() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { requireLogin } = useMiniGameAuth();
  const [isStart, setIsStart] = useState(false);
  const [dataApi, setDataApi] = useState(null);
  const [dataAward, setDataAward] = useState(null);
  const timeoutId = useRef(null);
  const selectorHome = useSelector(curStateHome);
  const { dataSpinUserMini, popupPiece, popupPuzzle } = useSelector(curStateMiniGame);
  const isPlayAttemptSuper = useRef(false);
  const dataSpin = dataSpinUserMini;
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  const [roundNumber, setRoundNumber] = useState(1);
  const [isRoundError, setIsRoundError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(``);
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [multipleSpinResults, setMultipleSpinResults] = useState({
    awards: [],
    total_rounds: 0,
    completed_rounds: 0,
  });
  const [isMultipleSpinLoading, setIsMultipleSpinLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const isMobileXsr = useMediaQuery(`(max-width: ${mediaQueryPoint.xsr}px)`);
  const [openPopupPiece, setOpenPopupPiece] = useState({});
  const queryClient = useQueryClient();

  const { data } = useQuery(getMiniGameGetMiniGameQuery(), {
    keepPreviousData: true,
  });
  const timeLeft = useCountdown(data?.minigame?.start_time, data?.minigame?.end_time);

  const totalPlayer = useMemo(
    () => data?.minigame?.total_player ?? 0,
    [data]
  );

  const dataPopup = useRef({
    variant: null,
  });

  const [turn, setTurn] = useState(1);
  const [openPopupChangeCoin, setOpenPopupChangeCoin] = useState(false);
  const [openPopupChangeCoinSuccess, setOpenPopupChangeCoinSuccess] = useState(false);

  const changeAttemptMutation = useMutation({
    mutationFn: postMiniGameChangeAttempt,
    onSuccess: async (data) => {
      dispatch(getDataSpinAwardMiniGame());
      dispatch(getDataMissionMiniGame());
      const res = await dispatch(getDataSpinUserMiniGame());
      dispatch(
        setDataSpinLeft({
          spin_left: res?.spin_left,
          spin_left_free: res?.spin_left_free,
          spin_left_super: res?.spin_left_super,
        }),
      );
      setOpenPopupChangeCoin(false);
      setOpenPopupChangeCoinSuccess(true);
    },
    onError: (error) => {
      console.log("Error", error);
    },
  });

  const handleSubmitChangeCoin = async () => {
    changeAttemptMutation.mutate(
      {
        bid_number: turn,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([queryKeyTurn]);
        },
      }
    );
  };

  useEffect(() => {
    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [timeoutId]);

  const showItemAttempts = () => {
    // if (dataSpin.spin_left_free) {
    //   return (
    //     <>
    //       <img
    //         src={IS_EVENT_NEW_YEAR_2025_THEME ? iconBid : attemptCoin}
    //         alt=""
    //         height={40}
    //         className="icon-coins"
    //       />
    //       <div className="attempts-number-wrapper">
    //         {/* ကစားခွင့်
    //         <span className="attempts-number">
    //           {" "}
    //           {dataSpin.spin_left_free}{" "}
    //         </span>{" "}
    //         coin ကျန်ပါသည် */}
    //         <span>{t('players_now')}</span>
    //       </div>
    //     </>
    //   );
    // }

    // if (dataSpin.spin_left_super) {
    //   return (
    //     <>
    //       <img
    //         src={IS_EVENT_NEW_YEAR_2025_THEME ? iconCoinSuperNewYear : superAttemptIcon}
    //         alt=""
    //         height={40}
    //         className="icon-coins"
    //       />
    //       <div className="attempts-number-wrapper">
    //         {dataSpin.spin_left_super > 1
    //           ? `${dataSpin.spin_left_super} SUPER coin ကျန်ရှိသည်။`
    //           : "SUPER coin  1 ခု ကျန်ရှိသည်။"}
    //       </div>
    //     </>
    //   );
    // }

    return (
      <>
        <img
          src={IS_EVENT_NEW_YEAR_2025_THEME ? iconBid : attemptCoin}
          alt=""
          height={40}
          className="icon-coins"
        />
        <div className="attempts-number-wrapper">
          <span className="attempts-number">{totalPlayer || 0}</span>{" "}
          {/* {dataSpin.spin_left > 1
            ? t("event_thingyan.home_page.coins_left").replace("coin", "coins")
            : dataSpin.spin_left === 1
              ? t("event_thingyan.home_page.coins_left").replace("coins", "coin")
              : "Coin မရှိပါ"} */}
          <span>{t('players_now')}</span>
        </div>
      </>
    );
  };

  const handlePlayLoto = async () => {
    // Mở comment để test quay reel
    // let dataApi = {};
    // dataPopup.current = {};
    // let currentProduct = [];
    // setIsStart(true);
    //           setTimeout(() => {
    //             setIsStart(false);
    //             const dataApi = {data : {award: {
    //                 "id": 2,
    //                 "name": "Free turn",
    //                 "type": "BID_FREE",
    //                 "value": 2,
    //                 "obj_puzzle_piece": null
    //             } }}
    //             dispatch(
    //               setOpenPopupPiece({
    //                 isShowPopupPiece: true,
    //                 type: ID_GIFT_PLAY_LOTO_MINIGAME.bid_free,
    //                 data: {
    //                   ...dataApi.data.award,
    //                   bidProduct: 1,
    //                 },
    //               })
    //             );
    //           }, 3500);
    //         return;

    // check user đăng nhập chưa
    if (!requireLogin()) {
      return;
    }

    // hết lượt quay
    if (!dataSpin.spin_left_super && !dataSpin.spin_left_free && !dataSpin.spin_left) {
      setRoundNumber(parseInt(MIN_ROUND));
      return setOpenPopupPiece({
        isShowPopupPiece: true,
        type: ID_GIFT_PLAY_LOTO_MINIGAME.no_coins,
      });
    }
    let dataApi = {};

    dataPopup.current = {};

    if (roundNumber > 1) {
      setIsStart(true);
      setIsMultipleSpinLoading(true);

      await postDataApi(API_PATH.miniGamePlayLotoMultiple, {
        rounds: roundNumber,
      }).then((res) => {
        const {
          awards,
          total_rounds,
          completed_rounds,
          spin_left,
          spin_left_free,
          spin_left_super,
        } = res?.data || {};

        setIsMultipleSpinLoading(false);

        if (!res || !res?.data || !res?.success) {
          console.log(res, "res");
          setIsShowPopup(false);
          setIsStart(false);
          return dispatch(
            setDataPopupError({
              isOpen: true,
              message: "",
            }),
          );
        } else {
          let id = null;
          id = setTimeout(() => {
            setIsShowPopup(true);
          }, 3500);
          const lastAward = awards[awards.length - 1] || {};
          dataPopup.current = {
            // variant: VARIANT.multipleRound,
            dataCongratesApi: lastAward,
          };

          dispatch(
            setDataSpinLeft({
              spin_left,
              spin_left_free,
              spin_left_super,
            }),
          );
          setMultipleSpinResults({
            awards,
            total_rounds,
            completed_rounds,
          });
          timeoutId.current = id;
        }
      });
    } else if (roundNumber === 1) {
      setIsStart(true);
      dataApi = (await postDataApi(API_PATH.miniGamePlayLoto)) || {};
      if (!dataApi || !dataApi?.data || !dataApi?.success) {
        setIsStart(false);
        return dispatch(
          setDataPopupError({
            isOpen: true,
            message: "",
          }),
        );
      } else {
        let id = null;
        dataPopup.current = {
          // variant: VARIANT.goodLuck,
          dataCongratesApi: dataApi.data.award,
          handleActionBtn:
            +dataApi.data?.award.id === ID_GIFT_PLAY_LOTO.bid_free
              ? () => navigate(`${PATH.BID}/running`)
              : null,
          isReel: +dataApi.data?.award.id === ID_GIFT_PLAY_LOTO.bid_free ? true : false,
        };

        if (dataApi.data?.award?.type === ID_GIFT_PLAY_LOTO_MINIGAME.good_luck) {
          id = setTimeout(() => {
            setIsStart(false);
            dispatch(
              setOpenPopupPiece({
                isShowPopupPiece: true,
                type: ID_GIFT_PLAY_LOTO_MINIGAME.good_luck,
              }),
            );
          }, 3500);
        }
        if (dataApi.data?.award.type === ID_GIFT_PLAY_LOTO_MINIGAME.bid_free) {
          let currentProduct = [];
          if (selectorHome?.bidProduct?.length > 0) {
            currentProduct = selectorHome.bidProduct.filter(
              (product) => new Date(product?.start_time).getTime() < currentDate,
            );
          }

          id = setTimeout(() => {
            setIsStart(false);
            dispatch(
              setOpenPopupPiece({
                isShowPopupPiece: true,
                type: ID_GIFT_PLAY_LOTO_MINIGAME.bid_free,
                data: {
                  ...dataApi.data.award,
                },
              }),
            );
          }, 3500);
        }
        if (dataApi.data?.award.type === ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece) {
          id = setTimeout(() => {
            setIsStart(false);
            dispatch(
              setOpenPopupPiece({
                isShowPopupPiece: true,
                type: dataApi?.data?.typeSpin === 'SUPER' ? ID_GIFT_PLAY_LOTO_MINIGAME.coin_super : ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece,
                data: dataApi.data.award,
              }),
            );
            if (+dataApi.data?.award?.obj_puzzle_piece?.type_take_prize === 1) {
              setDataAward(dataApi.data?.award);
            }
          }, 3500);
        }
        if (dataApi.data?.award.type === ID_GIFT_PLAY_LOTO_MINIGAME.add_spin) {
          id = setTimeout(() => {
            setIsStart(false);
            dispatch(
              setOpenPopupPiece({
                isShowPopupPiece: true,
                type: ID_GIFT_PLAY_LOTO_MINIGAME.add_spin,
                data: {
                  award: {
                    value: dataApi.data.award.value,
                  },
                },
              }),
            );
          }, 3500);
        }

        // set lượt quay redux
        // if (+dataApi.data?.award.id !== ID_GIFT_PLAY_LOTO.add_spin) {
        const { spin_left = 0, spin_left_free = 0, spin_left_super = 0 } = dataApi.data || {};

        dispatch(
          setDataSpinLeft({
            spin_left,
            spin_left_free,
            spin_left_super,
          }),
        );
        // }
        timeoutId.current = id;
      }
    }

    // lỗi api

    // console.log("dataApi", dataApi);

    // Hiển thị hộp quà

    // if (roundNumber === 1) {

    // }
    // else if (roundNumber > 1) {

    // }
  };

  const handleDecreaseRound = () => {
    if (!requireLogin()) {
      return;
    }
    if (roundNumber > MIN_ROUND) {
      setRoundNumber(parseInt(roundNumber) - 1);
    } else {
      setRoundNumber(parseInt(MIN_ROUND));
      setIsRoundError(true);
      setErrorMessage(t("reel_error_message.min_round").replace("_X_", MIN_ROUND));
      setTimeout(() => {
        setIsRoundError(false);
        setErrorMessage("");
      }, 4000);
    }
  };

  const handleIncreaseRound = () => {
    if (!requireLogin()) {
      return;
    }
    // check không được vượt quá số lượt quay hiện có của user. Nếu user có hơn 100 lượt quay thì vẫn chỉ được chọn tối đa 100 lượt quay
    const maxCurrentUserRound =
      dataSpin.spin_left + dataSpin.spin_left_free + dataSpin.spin_left_super || 0;
    // let maxCurrentUserRound = 0;
    // if (dataSpin.spin_left_free > 0) {
    //   maxCurrentUserRound = dataSpin.spin_left_free;
    // } else if (dataSpin.spin_left_super > 0) {
    //   maxCurrentUserRound = dataSpin.spin_left_super;
    // } else if (dataSpin.spin_left > 0) {
    //   maxCurrentUserRound = dataSpin.spin_left;
    // }

    if (roundNumber < Math.min(MAX_ROUND, maxCurrentUserRound)) {
      // if (roundNumber < MAX_ROUND) {
      setRoundNumber(parseInt(roundNumber) + 1);
    } else {
      if (maxCurrentUserRound === 0) {
        setRoundNumber(parseInt(MIN_ROUND));
        return dispatch(
          setOpenPopupPiece({
            isShowPopupPiece: true,
            type: ID_GIFT_PLAY_LOTO_MINIGAME.no_coins,
          }),
        );
      }
      if (roundNumber >= maxCurrentUserRound) {
        setRoundNumber(parseInt(maxCurrentUserRound));
        setIsRoundError(true);
        setErrorMessage(t("reel_error_message.max_round").replace("_X_", maxCurrentUserRound));
        setTimeout(() => {
          setIsRoundError(false);
          setErrorMessage("");
        }, 4000);
      } else {
        setRoundNumber(parseInt(MAX_ROUND));
        setIsRoundError(true);
        setErrorMessage(t("reel_error_message.max_round").replace("_X_", MAX_ROUND));
        setTimeout(() => {
          setIsRoundError(false);
          setErrorMessage("");
        }, 4000);
      }
    }
  };

  // const handleInputRoundChange = (e) => {
  //   if (!selectorAccount.userInfo) {
  //     return dispatch(setOpenPopupLogin(true));
  //   }

  //   const value = e.target.value;

  //   // allow clearing while typing
  //   if (value === "") {
  //     setRoundNumber("");
  //     return;
  //   }

  //   // allow only digits and max 2 characters
  //   if (!/^\d+$/.test(value) || value.length > 2) return;

  //   // Keep as string to allow leading zeros while typing
  //   setRoundNumber(value);
  // }

  // const handleInputRoundBlur = () => {

  //   if (roundNumber === "") {
  //     setRoundNumber(parseInt(MIN_ROUND));
  //     return;
  //   }

  //   // Convert to number to remove leading zeros
  //   const num = Number(roundNumber);

  //   let maxCurrentUserRound = 0
  //   if (dataSpin.spin_left_free > 0) {
  //     maxCurrentUserRound = dataSpin.spin_left_free;
  //   } else if (dataSpin.spin_left_super > 0) {
  //     maxCurrentUserRound = dataSpin.spin_left_super;
  //   } else if (dataSpin.spin_left > 0) {
  //     maxCurrentUserRound = dataSpin.spin_left;
  //   }

  //   if (maxCurrentUserRound === 0) {
  //     setRoundNumber(parseInt(MIN_ROUND));
  //     return dispatch(
  //     setOpenPopupPiece({
  //         isShowPopupPiece: true,
  //         type: ID_GIFT_PLAY_LOTO_MINIGAME.no_coins,
  //       })
  //     );
  //   } else {
  //     if (num < MIN_ROUND) {
  //       setRoundNumber(parseInt(MIN_ROUND));
  //       setIsRoundError(true);
  //       setErrorMessage(`အနည်းဆုံး ${MIN_ROUND} အကြိမ်ဖြစ်ရမည်`);
  //       setTimeout(() => {
  //         setIsRoundError(false);
  //         setErrorMessage("");
  //       }, 4000);
  //     } else if (num > MAX_ROUND) {
  //       setRoundNumber(parseInt(MAX_ROUND));
  //       setIsRoundError(true);
  //       setErrorMessage(`အများဆုံး ${MAX_ROUND} အကြိမ်သာဖြစ်နိုင်သည်`);
  //       setTimeout(() => {
  //         setIsRoundError(false);
  //         setErrorMessage("");
  //       }, 4000);
  //     } else if (num > maxCurrentUserRound) {
  //       setRoundNumber(parseInt(maxCurrentUserRound));
  //       setIsRoundError(true);
  //       setErrorMessage(`အများဆုံး ${maxCurrentUserRound} အကြိမ်သာဖြစ်နိုင်သည်`);
  //       setTimeout(() => {
  //         setIsRoundError(false);
  //         setErrorMessage("");
  //       }, 4000);
  //     } else {
  //       // Remove leading zeros by setting the parsed number
  //       setRoundNumber(num);
  //     }
  //   }
  // }

  const memoCongratesApi = useMemo(
    () => dataPopup?.current?.dataCongratesApi,
    [dataPopup?.current?.dataCongratesApi],
  );
  return (
    <>
      {dataAward && !popupPiece?.isShowPopupPiece && !popupPuzzle.isShow ? (
        <PopupIntroGift dataAward={dataAward} setDataAward={setDataAward} />
      ) : null}
      <ReelContainer id="rell-container-minigame">
        <div
          className={`${_.includes(dataStylePopup, dataApi?.data?.award?.obj_puzzle_piece?.id)
            ? "container-style-popup"
            : ""
            }`}
        >
          <div
            className={`container-reel ${IS_EVENT_THADINGYUT_2025_THEME
              ? "thadingyut-theme"
              : IS_EVENT_NEW_YEAR_2025_THEME
                ? "new-year-25-theme"
                : ""
              }`}
          >
            <img
              src={IS_EVENT_NEW_YEAR_2025_THEME ? reelNewYear : reel}
              alt="reel"
              className="bg-reel"
            />
            <div className="detail-reel">
              <AttemptContainer className={`attempt ${errorMessage ? "error-mode" : ""}`}>
                {errorMessage ? (
                  <div className="error-message" key="error">
                    {errorMessage}
                  </div>
                ) : (
                  <div className="attempts-display" key="attempts">
                    {showItemAttempts()}
                    <div className="reel-date">
                      <div className="D">
                        <span>{timeLeft?.days || 0}</span>
                      </div>
                      <div className="H">
                        <span>{timeLeft?.hours || 0}</span>
                      </div>
                      <div className="M">
                        <span>{timeLeft?.minutes || 0}</span>
                      </div>
                    </div>
                  </div>
                )}
              </AttemptContainer>
            </div>

            <div className="reel-icons">
              {/* {isStart ? ( */}
              <LotoReel isStart={isStart} dataCongratesApi={memoCongratesApi} />
            </div>
            <PlayNowButton
              style={{ pointerEvents: `${isStart ? "none" : ""}` }}
              className={`${IS_EVENT_THADINGYUT_2025_THEME
                ? "thadingyut-theme"
                : IS_EVENT_NEW_YEAR_2025_THEME
                  ? "new-year-25-theme"
                  : ""
                }`}
            >
              {/* <div
                className="round-control"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <img src={!IS_EVENT_NEW_YEAR_2025_THEME ? minusBtn : minusBtnNewYear} alt="minus" onClick={handleDecreaseRound} />
                <div className={`round-container ${isRoundError ? 'round-error' : ''} ${IS_EVENT_NEW_YEAR_2025_THEME ? 'new-year-theme' : ''}`}>
                  <input
                    readOnly
                    type="number"
                    value={roundNumber}
                    min={MIN_ROUND}
                    max={MAX_ROUND}
                    maxLength={2}
                    pattern="[0-9]{2}"
                    className="round-number"
                    // onChange={handleInputRoundChange}
                    // onBlur={handleInputRoundBlur}
                    // onKeyDown={(e) => {
                    //   if (['-', '+', 'e', 'E', '.'].includes(e.key)) {
                    //     e.preventDefault();
                    //   }
                    // }}
                  />

                </div>
                <img src={!IS_EVENT_NEW_YEAR_2025_THEME ? addBtn : addBtnNewYear} alt="add" onClick={handleIncreaseRound} />
              </div> */}
              <img
                src={
                  IS_EVENT_THADINGYUT_2025_THEME
                    ? playNowThadingyutTheme
                    : IS_EVENT_NEW_YEAR_2025_THEME
                      ? playNowNewYearTheme
                      : i18n.language === 'en' ? playNow : playNowTBN
                }
                alt="playnow"
                className={`play-now-btn`}
                onClick={handlePlayLoto}
              />
              {/* {!IS_EVENT_NEW_YEAR_2025_THEME && (
                <img src={iconLight} alt="" className="play-now-light" />
              )} */}
            </PlayNowButton>
          </div>
        </div>
      </ReelContainer>

      <PopupCongPiece
        type={openPopupPiece.type}
        // type={'NO_COINS'}
        // isOpen={true}
        isOpen={openPopupPiece.isShowPopupPiece}
        data={openPopupPiece.data}
        PopupCongPiece
        setOpenPopupChangeCoin={setOpenPopupChangeCoin}
        setTurn={setTurn}
        turn={turn}
        onCancel={async () => {
          setOpenPopupPiece({
            isShowPopupPiece: false,
            type: null,
            data: {},
            turn: 0,
          });

          if (openPopupPiece.type === ID_GIFT_PLAY_LOTO_MINIGAME.bid_free) {
            dispatch(getTurnRemain({}));
          }
          if (openPopupPiece.type === ID_GIFT_PLAY_LOTO_MINIGAME.add_spin) {
            const res = await dispatch(getDataSpinUserMiniGame());
            // const { spin_left = 0, spin_left_free = 0, spin_left_super = 0 } = data || {};
            console.log(res, 'res');


            dispatch(
              setDataSpinLeft({
                spin_left: res?.spin_left,
                spin_left_free: res?.spin_left_free,
                spin_left_super: res?.spin_left_super,
              }),
            );
          }
        }}
      />

      <PopupChangeCoin
        visible={openPopupChangeCoin}
        type="change"
        bid={turn}
        setVisible={setOpenPopupChangeCoin}
        submit={handleSubmitChangeCoin}
        isLoading={changeAttemptMutation.isLoading}
      />

      <PopupChangeCoin
        visible={openPopupChangeCoinSuccess}
        setVisible={setOpenPopupChangeCoinSuccess}
        type="success"
        bid={turn}
        submit={() => {
          setOpenPopupChangeCoinSuccess(false);
          const element = document.getElementById("mission-section");

          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
            });
          }
        }}
      />

      {/* <PopupFooter
        isOpen={isShowPopup}
        onClose={() => {
          setIsShowPopup(false);
          setMultipleSpinResults({
            awards: [],
            total_rounds: 0,
            completed_rounds: 0,
          });
          setCurrentPage(1);
          setIsStart(false);
          const maxCurrentUserRound =
            dataSpin.spin_left + dataSpin.spin_left_free + dataSpin.spin_left_super || 0;
          // let maxCurrentUserRound = 0;
          // if (dataSpin.spin_left_free > 0) {
          //   maxCurrentUserRound = dataSpin.spin_left_free;
          // } else if (dataSpin.spin_left_super > 0) {
          //   maxCurrentUserRound = dataSpin.spin_left_super;
          // } else if (dataSpin.spin_left > 0) {
          //   maxCurrentUserRound = dataSpin.spin_left;
          // }
          if (maxCurrentUserRound === 0) {
            setRoundNumber(parseInt(MIN_ROUND));
          }
          if (roundNumber > Math.min(MAX_ROUND, maxCurrentUserRound)) {
            if (maxCurrentUserRound === 0) {
              setRoundNumber(parseInt(MIN_ROUND));
              return;
            }
            setRoundNumber(Math.min(MAX_ROUND, maxCurrentUserRound));
            // console.log('set to max', Math.min(MAX_ROUND, maxCurrentUserRound));
          }
          if (roundNumber < MIN_ROUND) {
            setRoundNumber(parseInt(MIN_ROUND));
          }
          dispatch(getTurnRemain({}));
        }}
      >
        <>
          <div className="header-mini-popup-rule">
            <img src={bgHeader} alt="" className="img-rule-mini" />
            <div className="content-rule-mini">{t("mini_game.pop_up_spin.title")}</div>
          </div>

          <Table
            className="table-multiple-spin-results"
            dataSource={multipleSpinResults.awards || []}
            loading={isMultipleSpinLoading}
            pagination={false}
            scroll={{
              y: 365,
            }}
          >
            <Table.Column
              title={t("mini_game.pop_up_ranking.no")}
              key="type"
              align="center"
              width={120}
              // width={isMobile ? "20%" : "15%"}
              render={(record) => {
                // console.log(record)
                switch (record.type) {
                  case "BID_FREE":
                    return <img src={iconBidFree} alt="" height={isMobileXsr ? 42 : 52} />;
                  case "ADD_SPIN":
                    return <img src={bgCoin} alt="" height={isMobileXsr ? 42 : 52} />;
                  case "GOOD_LUCK":
                    return <img src={iconGoodLuck} alt="" height={isMobileXsr ? 42 : 52} />;
                  case "PUZZLE_PIECE":
                    return <img src={iconPuzzlePiece} alt="" height={isMobileXsr ? 42 : 52} />;
                  default:
                    return null;
                }
              }}
            />

            <Table.Column
              key="name"
              align="left"
              render={(record) => {
                if (record.type == "PUZZLE_PIECE" && record.obj_puzzle_piece !== null) {
                  if (record.obj_puzzle_piece?.name && record.obj_puzzle_piece?.name !== "") {
                    return (
                      <span
                        style={{
                          fontSize: isMobileXsr ? 12 : 14,
                        }}
                      >
                        {`${record.name} - Piece ${record.obj_puzzle_piece?.name || ""}`}
                      </span>
                    );
                  } else {
                    return (
                      <span
                        style={{
                          fontSize: isMobileXsr ? 12 : 14,
                        }}
                      >
                        {record.name}
                      </span>
                    );
                  }
                }

                if (record.type == "GOOD_LUCK") {
                  return (
                    <span
                      style={{
                        fontSize: isMobileXsr ? 12 : 14,
                      }}
                    >
                      {`${t("mini_game.pop_up_good_luck.prefix")} ${t("mini_game.pop_up_good_luck.suffix")}`}
                    </span>
                  );
                }

                if (record.type == "BID_FREE") {
                  return (
                    <span
                      style={{
                        fontSize: isMobileXsr ? 12 : 14,
                      }}
                    >
                      {`${record.value} ${t("mini_game.pop_up_received_free_turns.suffix")} ${t("mini_game.pop_up_received_free_turns.suffix_2").replace("s", record.value > 1 ? "s" : "")}`}
                    </span>
                  );
                }

                if (record.type == "ADD_SPIN") {
                  return (
                    <span
                      style={{
                        fontSize: isMobileXsr ? 12 : 14,
                      }}
                    >
                      {`${record.value} Coin${record.value > 1 ? "s" : ""}`}
                    </span>
                  );
                }

                return (
                  <span
                    style={{
                      fontSize: isMobileXsr ? 12 : 14,
                    }}
                  >
                    {record.name}
                  </span>
                );
              }}
            />

            <Table.Column
              title={"Coin"}
              align="center"
              key="num"
              width={120}
              render={(record) => {
                switch (record.spin_type) {
                  case "FREE":
                    return (
                      <img
                        src={IS_EVENT_NEW_YEAR_2025_THEME ? iconBid : attemptCoin}
                        alt=""
                        height={isMobileXsr ? 32 : 40}
                        className="icon-coins"
                      />
                    );
                  case "SUPER":
                    return (
                      <img
                        src={IS_EVENT_NEW_YEAR_2025_THEME ? iconCoinSuperNewYear : superAttemptIcon}
                        alt=""
                        height={isMobileXsr ? 32 : 40}
                        className="icon-coins"
                      />
                    );
                  case "NORMAL":
                    return (
                      <img
                        src={IS_EVENT_NEW_YEAR_2025_THEME ? iconBid : attemptCoin}
                        alt=""
                        height={isMobileXsr ? 32 : 40}
                        className="icon-coins"
                      />
                    );
                  default:
                    return (
                      <img
                        src={IS_EVENT_NEW_YEAR_2025_THEME ? iconBid : attemptCoin}
                        alt=""
                        height={isMobileXsr ? 32 : 40}
                        className="icon-coins"
                      />
                    );
                }
              }}
            />
          </Table>
        </>
      </PopupFooter> */}
    </>
  );
}

const ReelContainer = styled.div`
  .container-style-popup {
    .title-logo {
      margin-top: 0;
      max-height: 100px;
    }

    .ant-modal-content .popup-content__title-text {
      line-height: 25px;
    }
    .ant-modal-content .shrikhand.medium {
      line-height: 32px;
      font-size: 28px;
    }
  }
  .container-reel {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    max-width: 1200px;
    margin: auto;

    .reel {
      position: relative;
      z-index: -1;
    }

    /* .reel-water {
      object-fit: contain;
      position: absolute;
      width: 100%;
    } */

    .reel-icons {
      display: flex;
      position: absolute;
      gap: 64px;
      top: 60%;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, -82%);
      height: fit-content;
      width: 100%;
      justify-content: center;
      align-items: center;

      @media (max-width: 575px) {
        top: 59%;
      }

      @media (min-width: 576px) and (max-width: 767px) {
        top: 61%;
      }

      @media (min-width: 768px) and (max-width: 991px) {
        top: 60%;
      }

      @media (min-width: 992px) and (max-width: 1199px) {
      }

      @media (min-width: 1200px) and (max-width: 1599px) {
        top: 57.5%;
      }

      .leaf-icon,
      .bid-icon,
      .puzzle-icon {
        position: relative;
        height: fit-content;
      }

      .puzzle-icon {
        left: 10px;
      }
    }

    @media (min-width: 1400px) {
      padding-top: 40px;
      margin-top: -30px;

      .bg-reel {
        height: 690px;
        /* width: 850px; */
        width: 100%;
        margin: 0 auto;
        pointer-events: none;
      }
      .attempt {
        top: 103px;
      }
    }

    @media (max-width: 1400px) {
      padding-top: 40px;
      margin-top: -40px;

      .bg-reel {
        height: 592px;
        width: 100%;
        margin: 0 auto;
        pointer-events: none;
      }

      .img-container {
        width: 80px;
      }

      .attempt {
        top: 88px;
      }
    }

    @media (max-width: 1200px) {
      .reel-icons {
        gap: 50px;
      }

      padding-top: 40px;
      .attempt {
        top: 77px;
      }
      .bg-reel {
        height: 510px;
        width: 100%;
        margin: 0 auto;
      }
    }

    @media (max-width: 1075px) {
      .reel-icons {
        gap: 28px;
      }

      padding-top: 40px;
      .attempt {
        /* top: 88px; */
        top: 74px;
        img {
          height: 32px;
        }
      }
      .bg-reel {
        height: 390px;
        width: 100%;
        margin: 0 auto;
      }

      .attempts-number-wrapper {
        font-size: 16px;
      }
    }

    @media (max-width: 992px) {
      .reel-icons {
        gap: 36px;
      }

      padding-top: 40px;
      .attempt {
        top: 65px;
      }
      .bg-reel {
        height: 330px;
        width: 100%;
        margin: 0 auto;
      }
    }

    @media (max-width: 768px) {
      padding-top: 40px;
      .attempt {
        top: 61px;
      }
      .bg-reel {
        height: 320px;
        width: 590px;
        margin: 0 auto;
      }
    }

    @media (max-width: 576px) {
      padding-top: 20px;
      margin-top: -32px;
      .attempt {
        top: 40px;
      }
      .bg-reel {
        height: 310px;
        width: 100%;
        margin: 0 auto;
      }
    }

    @media (max-width: 492px) {
      padding-top: 20px;
      .attempt {
        top: 39px;
        width: max-content;
      }
      .bg-reel {
        height: 250px;
        width: 100%;
        margin: 0 auto;
      }

      .attempt img {
        height: 15px;
      }

      .attempts-number-wrapper {
        font-size: 9px;
      }
    }

    @media (max-width: 412px) {
      padding-top: 30px;
      margin-top: -40px;
      .attempt {
        top: 46px;
      }
      .bg-reel {
        height: 215px;
        width: 100%;
        margin: 0 auto;
      }
    }
    @media (max-width: 375px) {
      padding-top: 30px;

      .bg-reel {
        height: 200px;
        width: 100%;
        margin: 0 auto;
      }

      .detail-reel {
        width: 100%;
      }

      .attempt {
        top: 46px;
      }
      .reel-icons {
        & > img {
          width: 55px;
        }

        .leaf-icon {
          width: 40px;
        }
      }
    }

    @media (max-width: 320px) {
      .reel-icons {
        gap: 12px;
      }
    }

    &.thadingyut-theme {
      @media (min-width: 1400px) {
        .attempt {
          top: 143px;
        }
      }

      @media (max-width: 1400px) {
        .attempt {
          top: 117px;
        }
      }

      @media (max-width: 1200px) {
        .attempt {
          top: 108px;
          img {
            height: 32px;
          }
        }
      }

      @media (max-width: 1075px) {
        .attempt {
          top: 101px;
        }
      }

      @media (max-width: 992px) {
        .attempt {
          top: 108px;
        }
      }

      @media (max-width: 768px) {
        .attempt {
          top: 101px;
        }
      }

      @media (max-width: 576px) {
        .attempt {
          top: 72px;
          img {
            height: 26px;
          }
        }
      }

      @media (max-width: 492px) {
        .attempt {
          top: 72px;
          width: max-content;
        }
      }

      @media (max-width: 412px) {
        .attempt {
          top: 72px;
          img {
            height: 20px;
          }
        }
      }
      @media (max-width: 375px) {
        .attempt {
          top: 68px;
        }
      }
    }

    &.new-year-25-theme {
      .error-message {
        color: #fff;
        top: 1px;
      }
      .attempt {
        img {
          width: 32px;
          height: 32px;
        }
      }
      .attempts-number {
        color: #fff;
      }
      @media (min-width: 1400px) {
        .attempt {
          top: 161px;
        }
      }

      @media (max-width: 1400px) {
        .attempt {
          top: 135px;
          img {
            width: 28px;
            height: 28px;
          }
        }
      }

      @media (max-width: 1200px) {
        .attempt {
          top: 120px;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }

      @media (max-width: 1075px) {
        .error-message {
          top: 0;
          font-size: 16px;
        }
        .attempt {
          top: 116px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      @media (max-width: 992px) {
        .error-message {
          top: 2px;
        }
        .attempt {
          top: 121px;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }

      @media (max-width: 768px) {
        .attempt {
          top: 113px;
        }
      }

      @media (max-width: 576px) {
        .error-message {
          top: 1px;
          font-size: 13px;
        }
        .attempt {
          top: 83px;
          img {
            width: 18px;
            height: 18px;
          }
        }
      }

      @media (max-width: 492px) {
        .attempt {
          top: 83px;
        }
      }

      @media (max-width: 412px) {
        .error-message {
          top: 2px;
          font-size: 12px;
        }
        .attempt {
          top: 78px;
        }
      }
      @media (max-width: 375px) {
        .attempt {
          top: 74px;
        }
      }
    }
  }
`;

const AttemptContainer = styled.div`
  position: absolute;
  top: 12%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease-in-out;

  .reel-date {
    position: absolute;
    top: 93px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    display: flex;
    gap: 40px;
    height: 50px;

    @media (max-width: 1400px) {
      top: 87px;
      height: 42px;
    }
    @media (max-width: 1200px) {
      top: 78px;
      gap: 30px;
      height: 35px;
    }
    @media (max-width: 1075px) {
      top: 56px;
      gap: 20px;
      height: 32px;
    }
    @media (max-width: 992px) {
      top: 51px;
      gap: 10px;
      height: 27px;
    }
    @media (max-width: 768px) {
      top: 52px;
      gap: 12px;
      height: 23px;
    }
    @media (max-width: 576px) {
      top: 51px;
      gap: 12px;
      height: 23px;
    }
    @media (max-width: 492px) {
      top: 38px;
      gap: 9px;
      height: 21px;
    }
    @media (max-width: 412px) {
      top: 33px;
      gap: 9px;
      height: 16px;
    }
    @media (max-width: 375px) {
      top: 30px;
      gap: 9px;
      height: 16px;
    }

    span {
      color: rgba(0, 23, 115, 1);
      font-size: 25px;
      font-weight: 700;
      padding: 0 20px;
      display: inline-block;
      margin-top: 18px;
      @media (max-width: 1400px) {
        font-size: 20px;
        margin-top: 14px;
      }
      @media (max-width: 1200px) {
        font-size: 17px;
        margin-top: 12px;
      }
      @media (max-width: 992px) {
        font-size: 14.5px;
        margin-top: 6px;
        padding: 0 15px;
      }
      @media (max-width: 768px) {
        font-size: 13px;
        margin-top: 5px;
        padding: 0 13px;
      }
      @media (max-width: 492px) {
        font-size: 8px;
        line-height: 8px;
        margin-top: 6px;
        padding: 0 8px;
      }
      @media (max-width: 412px) {
        font-size: 9px;
        margin-top: 6px;
        padding: 0 8px;
      }
      @media (max-width: 375px) {
        font-size: 7px;
        margin-top: 6px;
        padding: 0 7px;
      }
    }
    .H,
    .D,
    .M {
        background-size: cover;
      background-position: center;
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
      }
      @media (max-width: 492px) {
        height: 19px;
      }
      @media (max-width: 412px) {
        height: 18px;
      }
      @media (max-width: 375px) {
             height: 16px;
    }

    }
    .H {
      background-image: url(${DateH});
    }
    .D {
      background-image: url(${DateD});
    }
    .M {
      background-image: url(${DateM});
    }
  }
  .attempts-number-wrapper {
    font-weight: bold;
    color: #fff;
    font-size: 24px;

    .attempts-number {
      color: rgba(255, 191, 31, 1);
      font-weight: bold;
    }
  }

  .attempts-display {
    display: flex;
    align-items: center;
    gap: 8px;
    animation: attemptsSlideIn 0.4s ease-out;
  }

  .error-message {
    font-weight: bold;
    color: #ff4444;
    font-size: 20px;
    text-align: center;
    animation:
      errorSlideIn 0.3s ease-out,
      errorBlink 0.8s ease-in-out 0.3s 2,
      errorSlideOut 0.3s ease-in 3.7s forwards;
    /* background: rgba(255, 255, 255, 0.95); */
    /* padding: 8px 16px; */
    border-radius: 8px;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); */
    position: relative;
    top: 6px;
  }

  &.error-mode {
    animation: errorPulse 0.3s ease-in-out;
  }

  @keyframes attemptsSlideIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes errorSlideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes errorSlideOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }

  @keyframes errorBlink {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  @keyframes errorPulse {
    0%,
    100% {
      transform: translateX(-50%) scale(1);
    }
    50% {
      transform: translateX(-50%) scale(1);
    }
  }

  @media (max-width: 1200px) {
    .error-message {
      font-size: 18px;
      top: 8px;
    }
  }

  @media (max-width: 1152px) {
    top: 12%;
  }
  @media (max-width: 1080px) {
    top: 11%;
  }

  @media (max-width: 992px) {
    .error-message {
      top: 6px;
    }
  }

  @media (max-width: 700px) {
    top: 10%;
  }
  @media (max-width: 652px) {
  }

  @media (max-width: 576px) {
    top: calc(10.5%);

    .icon-coins {
      height: 32px;
    }

    .attempts-number-wrapper {
      font-size: 16px;
    }

    .error-message {
      font-size: 16px;
    }
  }

  @media (max-width: 492px) {
    top: 10%;
    & > img {
      width: 25px;
      height: 25px;
    }
    .attempts-number-wrapper {
      font-size: 16px;
    }

    .error-message {
      font-size: 15px;
      top: 4px;
    }
  }

  @media (max-width: 440px) {
    top: 10.7%;
  }

  @media (max-width: 425px) {
    top: 12%;
    & > img {
      width: 25px;
      height: 25px;
    }
    .attempts-number-wrapper {
      font-size: 15px;
    }

    .error-message {
      font-size: 12px;
      top: 6px;
    }
  }

  @media (max-width: 392px) {
    top: 13%;
  }

  @media (max-width: 375px) {
    top: 11%;
  }

  @media (max-width: 350px) {
    .attempts-number-wrapper {
      font-size: 14px;
    }

    .error-message {
      font-size: 12px;
    }
  }

  @media (max-width: 320px) {
    top: 13%;
    & > img {
      width: 18px;
      height: 18px;
    }
  }
`;

const PlayNowButton = styled.div`
  position: absolute;
  bottom: 0;
  left: calc(50%);
  transform: translate(-52%, -55%);
  cursor: pointer;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .play-now-btn {
    width: 100%;
  }

  .play-now-light {
    position: absolute;
    left: 140px;
    top: -28px;
    pointer-events: none;
  }

  .round-control {
    img {
      width: 70px;
      cursor: pointer;
    }
  }

  .round-container {
    width: 125px;
    background: linear-gradient(180deg, #faf270 0%, #ffac08 100%);
    border: 1px solid #de172c;
    border-radius: 8px;
    padding: 2px 0;
    position: relative;
    top: 0px;

    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &.new-year-theme {
      .round-number {
        background: linear-gradient(180deg, #ffffff 0%, #fccfcf 47%, #ffffff 100%);
        background-clip: text;
        caret-color: #fff;
        /* opacity: 1;
        &:disabled {
          background: linear-gradient(180deg, #FFFFFF 0%, #FCCFCF 47%, #FFFFFF 100%)!important;
          background-clip: text!important;
          caret-color: #fff!important;
        } */
      }
    }

    .round-number {
      font-weight: 900;
      font-size: 24px;
      color: #fff;
      position: relative;
      transition: all 0.1s ease-in-out;
      text-align: center;
      background: linear-gradient(
        180deg,
        #d98643 0%,
        #954911 47%,
        #d98643 100%
      ); /* Define the gradient */
      -webkit-background-clip: text; /* Clip the background to the text shape (for webkit browsers) */
      background-clip: text; /* Clip the background to the text shape */
      -webkit-text-fill-color: transparent; /* Make the text itself transparent (for webkit browsers) */
      text-fill-color: transparent;
      width: 100%;
      max-height: 24px;
      caret-color: #954911;
      appearance: textfield;

      .ant-input-number-input {
        font-family: inherit;
        font-weight: 900;
        text-align: center;
        height: 100%;
      }
    }

    .round-number,
    .round-number:focus,
    .round-number:active,
    .round-number:hover,
    .round-number:focus-visible {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }

    &.round-error {
      .round-number {
        animation: shake 0.5s ease-in-out;
      }
    }
    @keyframes shake {
      0%,
      100% {
        transform: translateX(0);
      }
      10%,
      30%,
      50%,
      70%,
      90% {
        transform: translateX(-5px);
      }
      20%,
      40%,
      60%,
      80% {
        transform: translateX(5px);
      }
    }
  }

  @media (max-width: 1400px) {
    /* bottom: -57px; */
    max-width: 100%;
    transform: translate(-50%, -50%);
    left: calc(53% - 36px);

    .play-now-light {
      display: none;
    }

    .play-now-btn {
      /* display: none; */
      width: 100%;
    }
  }

  @media (max-width: 1200px) {
    bottom: 0;
    left: calc(53% - 29.5px);

    .play-now-btn {
      width: 100%;
    }
  }

  @media (max-width: 1075px) {
    /* max-width: 180px; */
    /* bottom: -56px; */
    left: calc(53% - 28px);
    transform: translate(-50%, -55%);

    .round-control {
      img {
        width: 60px;
      }
    }

    .round-container {
      .round-number {
        font-size: 22px;
      }
    }

    .play-now-btn {
      width: 100%;
    }
  }

  @media (max-width: 992px) {
    /* bottom: -55px; */
    /* max-width: 260px; */
    left: calc(53% - 34px);
    .play-now-btn {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    transform: translate(-47%, -50%);
    .play-now-btn {
      width:100%;
      max-width: 300px;
    }
  }

  @media (max-width: 576px) {
    /* max-width: 160px; */
    /* bottom: -20px; */
    left: calc(53% - 21.5px);
    transform: translate(-50%, -48%);
    .play-now-btn {
      width: 100%;
    }

    .round-control {
      img {
        width: 52px;
      }
    }

    .round-container {
      width: 80px;
      .round-number {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 492px) {
    /* bottom: -17px; */
    /* max-width: 140px; */
    transform: translate(-47%, -48%);
  }

  @media (max-width: 652px) {
    & > img {
      width: 275px;
    }
  }

  @media (max-width: 412px) {
    transform: translate(-50%, -47%);
    /* max-width: 120px; */
    left: calc(53% - 14.5px);

    .play-now-btn {
      width: 100%;
    }

    .round-control {
      img {
        width: 46px;
      }
    }

    .round-container {
      width: 60px;
      .round-number {
        font-size: 16px;
      }
    }
  }

  @media (max-width: 375px) {
    transform: translate(-50%, -40%);
  }

  @media (max-width: 335px) {
    transform: translate(-50%, -40%);
  }

  @media (max-width: 320px) {
    & > img {
      width: 150px;
    }
  }

  &.thadingyut-theme {
    position: absolute;
    bottom: -37px;
    left: calc(53% - -2px);
    transform: translate(-62%, -115%);
    cursor: pointer;
    max-width: 370px;

    @media (max-width: 1400px) {
      bottom: -57px;
      max-width: 310px;
      transform: translate(-45%, -125%);
      left: calc(53% - 36px);
    }

    @media (max-width: 1200px) {
      max-width: 200px;
      bottom: -75px;
      left: calc(53% - 29.5px);
      transform: translate(-45%, -145%);
    }

    @media (max-width: 1075px) {
      max-width: 180px;
      bottom: -56px;
      left: calc(53% - 28px);
      transform: translate(-45%, -135%);
    }

    @media (max-width: 992px) {
      bottom: -55px;
      max-width: 260px;
      left: calc(53% - 34px);
      transform: translate(-45%, -120%);
    }

    @media (max-width: 768px) {
      transform: translate(-42%, -115%);
    }

    @media (max-width: 576px) {
      max-width: 160px;
      bottom: -20px;
      left: calc(53% - 21.5px);
      transform: translate(-45%, -87%);
      & > img {
        width: 250px;
      }
    }

    @media (max-width: 652px) {
      & > img {
        width: 275px;
      }
    }

    @media (max-width: 492px) {
      bottom: -17px;
      max-width: 140px;
      transform: translate(-40%, -110%);
      & > img {
        width: 200px;
      }
    }

    @media (max-width: 412px) {
      transform: translate(-40%, -95%);
      max-width: 120px;
      left: calc(53% - 18.5px);
    }

    @media (max-width: 375px) {
      transform: translate(-40%, -90%);
      & > img {
        width: 180px;
      }
    }

    @media (max-width: 335px) {
      transform: translate(-40%, -87%);
    }

    @media (max-width: 320px) {
      & > img {
        width: 150px;
      }
    }
  }

  &.new-year-25-theme {
    position: absolute;
    bottom: 3.5%;
    left: calc(50%);
    transform: translate(-50%, -50%);
    cursor: pointer;
    margin: 0 auto;
    /* max-width: 270px; */
    text-align: center;

    .play-now-btn {
      width: 250px;
      // height: 48px;
    }

    .round-control {
      img {
        width: 64px;
        cursor: pointer;
      }
    }

    .round-container {
      width: 170px;
      background: rgba(255, 99, 70, 0.7);
      border: 1px solid #e10603;
      border-radius: 8px;
      padding: 2px 0;
      position: relative;
      top: -3px;
      max-height: 30px;

      .round-number {
        font-weight: bold;
        font-size: 24px;
        color: #fff;
        position: relative;
        transition: all 0.1s ease-in-out;
        text-align: center;
        appearance: textfield;
      }
    }

    @media (max-width: 1400px) {
      bottom: 3.5%;
      min-width: 310px;
      transform: translate(-50%, -50%);
      left: calc(53% - 25px);
      .play-now-btn {
        width: 185px;
      }

      .round-control {
        img {
          width: 56px;
        }
      }

      .round-container {
        width: 150px;
        .round-number {
          font-size: 20px;
        }
      }
    }

    @media (max-width: 1200px) {
      bottom: 4.5%;
      left: calc(53% - 25px);
      /* transform: translate(-44%, -50%); */
      .play-now-btn {
        width: 150px;
      }
      .round-control {
        img {
          width: 46px;
        }
      }
      .round-container {
        width: 125px;
      }
    }

    @media (max-width: 1075px) {
      /* min-width: 200px; */
      bottom: 2.75%;
      left: calc(53% - 24px);
      /* transform: translate(-40%, -50%); */
    }

    @media (max-width: 992px) {
      bottom: 4.5%;
      /* min-width: 260px; */
      left: calc(53% - 24px);
      /* transform: translate(-43%, -120%); */
    }

    @media (max-width: 768px) {
      bottom: 4%;
      /* transform: translate(-39%, -106%); */
      .round-control {
        height: 31px;
      }
    }

    @media (max-width: 576px) {
      /* min-width: 200px; */
      bottom: 3.5%;
      left: calc(53% - 16px);
      /* transform: translate(-42%, -92%); */
      .play-now-btn {
        width: 130px;
      }

      .round-control {
        height: 24px;
        img {
          width: 40px;
        }
      }

      .round-container {
        width: 100px;
        .round-number {
          font-size: 16px;
        }
      }
    }

    @media (max-width: 492px) {
      bottom: 4%;
      /* min-width: 140px; */
      /* transform: translate(-38%, -105%); */
      .play-now-btn {
        /* height: 34px; */
        width: 125px;
      }
      .round-container {
        width: 80px;
      }
    }

    @media (max-width: 412px) {
      bottom: 2%;
      /* transform: translate(-38%, -132%); */
      /* min-width: 120px; */
      left: calc(53% - 10px);
      .play-now-btn {
        /* height: 28px; */
        width: 110px;
      }
      .round-control {
        height: 21px;
        img {
          width: 36px;
        }
      }

      .round-container {
        width: 80px;
        .round-number {
          font-size: 14px;
        }
      }
    }

    @media (max-width: 375px) {
      /* transform: translate(-38%, -85%); */
      bottom: 2%;
      .play-now-btn {
        /* height: 28px; */
        width: 90px;
      }
    }

    @media (max-width: 335px) {
      /* transform: translate(-38%, -88%); */
    }
  }
`;

export default Reel;
